export const CaregiversTabs = Object.freeze({
  ACTIVE: {
    text: 'Active',
  },
  NOT_ACTIVE: {
    text: 'Not Active',
  },
  ALL: {
    text: 'All',
  },
});

export const DefaultTabInfo = Object.freeze({
  ACTIVE: {
    text: CaregiversTabs.ACTIVE.text,
    count: 0,
  },
  NOT_ACTIVE: {
    text: CaregiversTabs.NOT_ACTIVE.text,
    count: 0,
  },
  ALL: {
    text: CaregiversTabs.ALL.text,
    count: 0,
  },
});

export const TableHeaders = [
  { column: 'firstName', label: 'First Name', width: '13%', sortBy: 'text' },
  { column: 'lastName', label: 'Last Name', width: '13%', sortBy: 'text' },
  { column: 'isPrimary', label: 'Is Primary?', width: '8%', sortBy: 'value' },
  { column: 'phone', label: 'Phone', width: '10%', sortBy: 'text' },
  { column: 'dateOfBirth', label: 'Date of Birth', width: '8%', sortBy: 'value' },
  { column: 'relationship', label: 'Relationship', width: '12%', sortBy: 'text' },
  { column: 'medicareStatus', label: 'Medicare Status', width: '8%', sortBy: 'text' },
  { column: 'actions', label: 'Actions', width: '28%' },
];
